import { render, staticRenderFns } from "./PlainRouterView.vue?vue&type=template&id=7e1fd0a4"
import script from "./PlainRouterView.vue?vue&type=script&lang=js"
export * from "./PlainRouterView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e1fd0a4')) {
      api.createRecord('7e1fd0a4', component.options)
    } else {
      api.reload('7e1fd0a4', component.options)
    }
    module.hot.accept("./PlainRouterView.vue?vue&type=template&id=7e1fd0a4", function () {
      api.rerender('7e1fd0a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PlainRouterView.vue"
export default component.exports